import { BoxStaffRole } from "@modules/boxStaff/gateway/boxStaffDto"
import { word } from "@modules/core/utils/i18n"
import * as Yup from "yup"

export function modifiedBoxStaffYupValidationSchema(oldNote: string | undefined) {
  return Yup.object({
    internalNote: Yup.string()
      .optional()
      .test("internalNote", word("box.staff.table.dayToDay.internalNote.error"), (value) => value !== oldNote),
    role: Yup.mixed<BoxStaffRole>().oneOf(Object.values(BoxStaffRole)).required(),
  })
}

export function addStaffYupValidationSchema() {
  return Yup.object({
    userId: Yup.string(),
    userEmail: Yup.string().email(word("global.input.email.error")),
    role: Yup.mixed<BoxStaffRole>().oneOf(Object.values(BoxStaffRole)).required("global.input.required"),
  }).test((value, context) => {
    if (!value.userId && !value.userEmail) {
      return new Yup.ValidationError(word("box.staff.addBoxStaffInput.emailOrId.error"), value.userId, context.path)
    }
    return true
  })
}
